import React, { useEffect } from "react";
import Footer from '../../components/Footer'
import HomeContact from "../../components/HomeContact";
import ScrollToTop from "../../components/ScrollToTop";
import ContactBanner from "../../components/Banner/ContactBanner";
export default function Contact() {

    useEffect(() => {
        document.title = 'MinMin Wedding - Phóng Sự Cưới | Contact';
    }, []);
    return (
        <>
            <ScrollToTop />
            <ContactBanner />
            <div>
                <HomeContact />
            </div>
            <div>
                <Footer />
            </div>
        </>
    )
}